import { gql } from '../../../apollo/__generated__';

export const DELETE_EVENT = gql(`
  mutation DeleteEvent($eventId: ID!) {
    deleteEvent(eventId: $eventId) {
      id
    }
  }
`);
